<!-- <div class="clients py-3 pagination-order">
  <header
    class="user-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>{{ newHeading }}</h1>
    <div class="prospects-panel d-flex justify-content-between ms-2 me-auto">
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="All"
          [checked]="true"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getClientFilterOnChange($event)" />

        <span class="link">All</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="OrdersYes"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getClientFilterOnChange($event)" />

        <span class="link">Orders Yes</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="OrdersNo"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getClientFilterOnChange($event)" />

        <span class="link">Orders No</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="NoAvailCredit"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getClientFilterOnChange($event)" />

        <span class="link">No Avail Credit</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="NoProtection"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getClientFilterOnChange($event)" />

        <span class="link">No Protection</span>
      </label>
    </div>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="user-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="onClientRedirection()">Add New Client</a>
      </div>
    </div>
  </header>
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="filterClientList"
    [(selection)]="selectedClients"
    styleClass="p-datatable-customers cliet-listing search-more"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="false"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [filterDelay]="0"
    [paginator]="true"
    [rows]="20"
    (onFilter)="onFilter($event)">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem">Account</th>
        <th class="notes">
          <i class="icon icon-Notes me-2"></i> /
          <i class="icon icon-Attachment me-2"></i>
        </th>
        <th
          [ngClass]="{ trimmedby40char: organizationNameCharacterCond }"
          class="jname">
          Name
        </th>
        <th pSortableColumn="availableCredit">
          Available Credit
          <p-sortIcon field="availableCredit"></p-sortIcon>
        </th>
        <th pSortableColumn="clientPrimaryAddress">
          Address <p-sortIcon field="clientPrimaryAddress"></p-sortIcon>
        </th>
        <th>Contact</th>
        <th>BC</th>
        <th pSortableColumn="protectionNumber">
          Safe Days <p-sortIcon field="protectionNumber"></p-sortIcon>
        </th>
        <th>Billing Rep</th>
        <th>Last Order</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="customerAccount"
              id="customerAccount"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'customerAccount',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="organizationNameD365"
              id="organizationNameD365"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'organizationNameD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              id="clientPrimaryAddress"
              name="clientPrimaryAddress"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'clientPrimaryAddress',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              name="brandingconsultant"
              id="brandingconsultant"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'brandingconsultant',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th></th>
        <th>
          <jni-date-filter
            [dataList]="clientListings"
            [columnName]="lastOrderDateColumn"
            (emitCancelFilter)="clearFilter($event)"
            (emitApplyFilter)="applyFilter($event)"></jni-date-filter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-clientList>
      <tr class="p-selectable-row">
        <td style="width: 8rem">
          <p-checkbox
            inputId="account"
            [(ngModel)]="clientList.isActive"
            [binary]="true"
            class="me-2"
            (click)="checkboxSelection()"></p-checkbox>
          <a
            class="link"
            (click)="redirectToSummaryPage(clientList.customerAccount)"
            >{{ clientList.customerAccount }}</a
          >
        </td>

        <td class="notes">
          <i class="icon icon-Notes me-2"></i>
          <i class="icon icon-Attachment me-2"></i>
        </td>
        <td
          [ngClass]="{
            'trimmeddescription trimmedby40char': organizationNameCharacterCond,
          }"
          class="name">
          {{ organizationNameCharacterCount(clientList.organizationNameD365)
          }}{{ clientList.organizationNameD365 }}
        </td>
        <td>
          <span class="credit">{{
            clientList.revisedCreditLimitD365 | number: ".2"
          }}</span>
          <span class="ms-2">USD</span>
          <i
            *ngIf="clientList.availableCredit === 0"
            class="icon icon-Error ms-2"></i>
        </td>
        <td>{{ clientList.clientPrimaryAddress }}</td>
        <td>
          <span class="c-title">{{ clientList.primaryContactName }}</span>
          <a
            style="text-decoration: none"
            [title]="clientList.primaryContactNumber"
            [href]="'tel:' + clientList.primaryContactNumber"
            ><i
              class="icon icon-Call ms-2"
              *ngIf="clientList.primaryContactNumber">
            </i>
          </a>
          <a
            style="text-decoration: none"
            [title]="clientList.primaryContactEmail"
            [href]="'mailto:' + clientList.primaryContactEmail">
            <i
              class="icon icon-Email ms-2"
              *ngIf="clientList.primaryContactEmail">
            </i>
          </a>
        </td>
        <td>{{ clientList.brandingconsultant }}</td>
        <td>
          <span *ngIf="clientList?.protectionNumber !== -1">
            {{ clientList.protectionNumber }}
          </span>
        </td>
        <td>{{ clientList.billingRepD365 }}</td>
        <td>
          <a
            class="link"
            (click)="redirectToOrderListingPage(clientList.customerAccount)"
            >{{ clientList?.lastOrderDate | date: "yyyy-MM-dd" }}</a
          >
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No users found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-client-details>
  </div>
</jni-modal-stacker> -->

<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-3 align-items-end">
          <h2 class="mb-0">{{ newHeading }}</h2>
          <jni-spinner *ngIf="showSmallLoader"></jni-spinner>

          <div class="flex items-center">
            <p-radiobutton
              inputId="All"
              value="All"
              type="radio"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              (onClick)="getClientFilterOnChange($event)" />
            <label for="ingredient1" class="ml-2">All</label>
          </div>

          <div class="flex items-center">
            <p-radiobutton
              inputId="OrdersYes"
              value="OrdersYes"
              type="radio"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              (onClick)="getClientFilterOnChange($event)" />
            <label for="ingredient1" class="ml-2">Orders Yes</label>
          </div>

          <div class="flex items-center">
            <p-radiobutton
              inputId="OrdersNo"
              value="OrdersNo"
              type="radio"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              (onClick)="getClientFilterOnChange($event)" />
            <label for="ingredient1" class="ml-2">Orders No</label>
          </div>

          <div class="flex items-center">
            <p-radiobutton
              inputId="NoAvailCredit"
              value="NoAvailCredit"
              type="radio"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              (onClick)="getClientFilterOnChange($event)" />
            <label for="ingredient1" class="ml-2">No Avail Credit</label>
          </div>

          <div class="flex items-center">
            <p-radiobutton
              inputId="NoProtection"
              value="NoProtection"
              type="radio"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              (onClick)="getClientFilterOnChange($event)" />
            <label for="ingredient1" class="ml-2">No Protection</label>
          </div>
        </span>

        <span
          class="d-flex gap-2 customizefilter-btn justify-content-between align-items-center">
          <p-button
            label="Export excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            class="link"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="Add New Client"
            icon="pi pi-plus"
            (click)="onClientRedirection()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          responsiveLayout="scroll"
          [value]="filterClientList"
          [(selection)]="selectedClients"
          styleClass="p-datatable-customers cliet-listing search-more"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowHover]="true"
          [rows]="defaultTake"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          [paginator]="true"
          [totalRecords]="totalRecords"
          [lazy]="true"
          sortMode="multiple"
          (onLazyLoad)="getClientsList($event)"
          selectionMode="multiple"
          styleClass="table-listing"
          [rows]="50">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Account</th>
              <th class="notes">
                <i class="icon icon-Notes me-2"></i>
                <i class="icon icon-Attachment me-2"></i>
              </th>
              <th
                [ngClass]="{ trimmedby40char: organizationNameCharacterCond }"
                class="jname">
                Name
              </th>
              <th pSortableColumn="availableCredit">
                Available Credit
                <p-sortIcon field="availableCredit"></p-sortIcon>
              </th>
              <th>Address</th>
              <th>Contact</th>
              <th>BC</th>
              <th>Safe Days</th>
              <th>Billing Rep</th>
              <th>Last Order</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex align-items-center">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerAccount"
                    id="customerAccount"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerAccount',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                  <span class="pi pi-filter-icon pi-filter ms-2"></span>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex align-items-center">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="organizationNameD365"
                    id="organizationNameD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'organizationNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                  <span class="pi pi-filter-icon pi-filter ms-2"></span>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex align-items-center">
                  <input
                    jniAutoCompleteBlocker
                    id="clientPrimaryAddress"
                    name="clientPrimaryAddress"
                    pInputText
                    type="text"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientPrimaryAddress',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                  <span class="pi pi-filter-icon pi-filter ms-2"></span>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex align-items-center">
                  <input
                    jniAutoCompleteBlocker
                    name="brandingconsultant"
                    id="brandingconsultant"
                    pInputText
                    type="text"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'brandingconsultant',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                  <span class="pi pi-filter-icon pi-filter ms-2"></span>
                </div>
              </th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-calendar
                    [showIcon]="false"
                    dateFormat="mm-dd-yy"
                    (onSelect)="dt.filter($event, 'lastOrderDate', 'equals')"
                    [appendTo]="'body'"
                    class="p-column-filter"></p-calendar>
                  <span class="pi pi-filter-icon pi-filter ms-2"></span>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-clientList>
            <tr class="p-selectable-row">
              <td>
                <p-checkbox
                  inputId="account"
                  [(ngModel)]="clientList.isActive"
                  [binary]="true"
                  class="me-2"
                  (click)="checkboxSelection()"></p-checkbox>
                <a
                  class="link"
                  (click)="redirectToSummaryPage(clientList.customerAccount)"
                  >{{ clientList.customerAccount }}</a
                >
              </td>

              <td class="notes">
                <i class="icon icon-Notes me-2"></i>
                <i class="icon icon-Attachment me-2"></i>
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby40char':
                    organizationNameCharacterCond,
                }"
                class="name text-truncate max-width-10"
                type="text"
                pTooltip="{{
                  organizationNameCharacterCond
                    ? clientList.organizationNameD365
                    : ''
                }}"
                tooltipPosition="top"
                tooltipStyleClass="tooltip-max-width-10">
                {{
                  organizationNameCharacterCount(
                    clientList.organizationNameD365
                  )
                }}{{ clientList.organizationNameD365 }}
              </td>
              <td>
                <span class="credit">{{
                  clientList.revisedCreditLimitD365 | number: ".2"
                }}</span>
                <span class="ms-2">USD</span>
                <i
                  *ngIf="clientList.availableCredit === 0"
                  class="icon icon-Error ms-2"></i>
              </td>
              <td>{{ clientList.clientPrimaryAddress }}</td>
              <td>
                <span class="c-title">{{ clientList.primaryContactName }}</span>
                <a
                  [title]="clientList.primaryContactNumber"
                  [href]="'tel:' + clientList.primaryContactNumber"
                  ><i
                    class="pi pi-phone ms-2"
                    *ngIf="clientList.primaryContactNumber">
                  </i>
                </a>
                <a
                  [title]="clientList.primaryContactEmail"
                  [href]="'mailto:' + clientList.primaryContactEmail">
                  <i
                    class="pi pi-envelope ms-2"
                    *ngIf="clientList.primaryContactEmail">
                  </i>
                </a>
              </td>
              <td>{{ clientList.brandingconsultant }}</td>
              <td>
                <span *ngIf="clientList?.protectionNumber !== -1">
                  {{ clientList.protectionNumber }}
                </span>
              </td>
              <td>{{ clientList.billingRepD365 }}</td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToOrderListingPage(clientList.customerAccount)
                  "
                  >{{ clientList?.lastOrderDate | date: "yyyy-MM-dd" }}</a
                >
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No users found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (closeEvent)="closeModalForClient()"
      (scrollHiddenStatus)="addScollHiddenClass()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker>
